module.exports = __webpack_public_path__ + "static/img/zsth.fe6790b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/zsth.jpg
// module id = Rhbg
// module chunks = 0